/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./assetsInfoM.vue?vue&type=template&id=324f4b7d"
import script from "./assetsInfoM.vue?vue&type=script&lang=js"
export * from "./assetsInfoM.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports